<template>
  <div
    class="g-recaptcha"
    :data-sitekey="siteKey"
    data-theme="light"
    data-callback="verifyMethod"
    data-expired-callback="expiredMethod"
    data-error-callback="errordMethod">
  </div>
</template>

<script>
import store from "../store";
import { mapGetters } from "vuex";

window.verifyMethod = (response) => {
  try {
  store.dispatch("user/setRecaptchaToken", response)
  store.dispatch("user/setRecaptchaStatus", 'success')
  } catch(e) {}
}
window.expiredMethod = () => {
  try {
  store.dispatch("user/setRecaptchaToken", null)
  store.dispatch("user/setRecaptchaStatus", 'expired')
  } catch(e) {}
}
window.errordMethod = () => {
  try{
    store.dispatch("user/setRecaptchaToken", null)
    store.dispatch("user/setRecaptchaStatus", 'error')
  } catch(e) {}
}

export default {
  props: {
    siteKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      recaptchaToken: "user/recaptchaToken",
    }),
  },
  watch: {
    recaptchaToken(newVal, old) {
      if(newVal !== old) {
        this.$emit('verify', newVal)
      }
    }
  },
  beforeCreate() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("id", "recapcha-script");
    recaptchaScript.setAttribute("async", "true");
    recaptchaScript.setAttribute("defer", "true");
    recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
    document.head.appendChild(recaptchaScript);
  },
  beforeDestroy() {
    document.querySelector('#recapcha-script').remove();
  }
}
</script>